import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$db37 from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/static.js'

const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 600,
    "md": 960,
    "lg": 1280,
    "xl": 1920,
    "xxl": 1536,
    "2xl": 1536,
    "placeholder": 10
  },
  "presets": {},
  "provider": "static",
  "intersectOptions": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$db37, defaults: {"domains":["0.0.0.0"]} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)
  inject('img', $img)
}
